module.exports = __webpack_public_path__ + "img/img-cc722aa8.d5088e04.png";